function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var OnePlayerGameTemplate = require('../../lib/templates/oneplayer-gametemplate');
var MahjongGameRulesTemplate = require('./lib/mahjong-game-rules.template');
var htmlTemplate = require('./lib/game-html.template');

//////////////////
// CONSTRUCTOR  //
//////////////////
var Mahjong = /*#__PURE__*/function (_OnePlayerGameTemplat) {
  function Mahjong(app) {
    var _this;
    _classCallCheck(this, Mahjong);
    _this = _callSuper(this, Mahjong, [app]);

    // show status and options in the sidebar, not floating over the board
    _defineProperty(_this, "firstColumn", 1);
    _defineProperty(_this, "lastColumn", 14);
    _defineProperty(_this, "emptyCells", [
    // bottom layer
    [1, 1], [1, 14], [2, 1], [2, 2], [2, 3], [2, 12], [2, 13], [2, 14], [3, 1], [3, 2], [3, 13], [3, 14], [4, 14], [5, 1], [6, 1], [6, 2], [6, 13], [6, 14], [7, 1], [7, 2], [7, 3], [7, 12], [7, 13], [7, 14], [8, 1], [8, 14],
    // 2nd layer
    [9, 1], [9, 2], [9, 3], [9, 4], [9, 11], [9, 12], [9, 13], [9, 14], [10, 1], [10, 2], [10, 3], [10, 4], [10, 11], [10, 12], [10, 13], [10, 14], [11, 1], [11, 2], [11, 3], [11, 4], [11, 11], [11, 12], [11, 13], [11, 14], [12, 1], [12, 2], [12, 3], [12, 4], [12, 11], [12, 12], [12, 13], [12, 14], [13, 1], [13, 2], [13, 3], [13, 4], [13, 11], [13, 12], [13, 13], [13, 14], [14, 1], [14, 2], [14, 3], [14, 4], [14, 11], [14, 12], [14, 13], [14, 14],
    // 3rd layer
    [15, 1], [15, 2], [15, 3], [15, 4], [15, 5], [15, 10], [15, 11], [15, 12], [15, 13], [15, 14], [16, 1], [16, 2], [16, 3], [16, 4], [16, 5], [16, 10], [16, 11], [16, 12], [16, 13], [16, 14], [17, 1], [17, 2], [17, 3], [17, 4], [17, 5], [17, 10], [17, 11], [17, 12], [17, 13], [17, 14], [18, 1], [18, 2], [18, 3], [18, 4], [18, 5], [18, 10], [18, 11], [18, 12], [18, 13], [18, 14],
    // 4th layer
    [19, 1], [19, 2], [19, 3], [19, 4], [19, 5], [19, 6], [19, 9], [19, 10], [19, 11], [19, 12], [19, 13], [19, 14], [20, 1], [20, 2], [20, 3], [20, 4], [20, 5], [20, 6], [20, 9], [20, 10], [20, 11], [20, 12], [20, 13], [20, 14],
    //5th layer (top)
    [21, 1], [21, 2], [21, 3], [21, 4], [21, 5], [21, 6], [21, 9], [21, 10], [21, 11], [21, 12], [21, 13], [21, 14]]);
    _this.hud.container = '.logobox';
    _this.app = app;
    _this.name = 'Mahjong';
    _this.slug = 'mahjong';
    _this.gamename = 'Mahjong';
    _this.game_length = 10; //Estimated number of minutes to complete a game
    _this.description = "3D solitary puzzle game with mahjong tiles, also known as Taipei. Match tiles to remove them from the board, clear the board to receive a lucky fortune";
    _this.categories = 'Games Cardgame One-player';
    _this.publisher_message = 'originally developed by Pawel (twitter: @PawelPawlak14). Feel free to pm me with any suggestions/feedback';
    _this.status = 'prod';
    _this["class"] = 'app';
    _this.social.creator = 'Pawel Pawlak';
    _this.social.twitter = '@PawelPawlak14';
    return _this;
  }
  _inherits(Mahjong, _OnePlayerGameTemplat);
  return _createClass(Mahjong, [{
    key: "returnGameRulesHTML",
    value: function returnGameRulesHTML() {
      return MahjongGameRulesTemplate(this.app, this);
    }

    //
    // runs the first time the game is created / initialized
    //
  }, {
    key: "initializeGame",
    value: function initializeGame(game_id) {
      console.log('GAMEID: ' + game_id);

      //
      // to persist data between games, such as board state, write it to
      // the game.state object. if this object does not exist, that tells
      // us this is the first time we have initialized this game.
      //
      if (!this.game.state) {
        //Just default 1 player game state (for the stats)
        this.game.state = this.returnState();
        this.game.state.hidden = [];
        this.newRound();
      } else {
        this.game.queue.push('READY');
      }
      this.saveGame(this.game.id);
    }

    //
    // runs whenever we load the game into the browser. render()
    //
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _this2 = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(!this.browser_active || this.initialize_game_run)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return this.injectGameHTML(htmlTemplate());
            case 2:
              _context.n = 3;
              return _superPropGet(Mahjong, "render", this, 3)([app]);
            case 3:
              this.menu.addMenuOption('game-game', 'Game');
              this.menu.addSubMenuOption('game-game', {
                text: 'Start New Game',
                id: 'game-new',
                "class": 'game-new',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.prependMove('lose');
                  game_mod.endTurn();
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'How to Play',
                id: 'game-intro',
                "class": 'game-intro',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.overlay.showClosable(game_mod.returnGameRulesHTML());
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Stats',
                id: 'game-stats',
                "class": 'game-stats',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.overlay.showClosable(game_mod.returnStatsHTML('Mahjong 统计'));
                }
              });
              this.menu.addChatMenu();

              //
              // render menu
              //
              this.menu.render();

              //
              // display the board?
              //
              if (this.game.board && this.game.deck) {
                this.displayBoard(0);
              }
              if (app.browser.isMobileBrowser(navigator.userAgent)) {
                this.hammer.rightJustify = true;
                this.hammer.render('#mahj-rowbox', 900);
              } else {
                this.sizer.render();
                this.sizer.attachEvents('#mahj-rowbox');
                $('#mahj-rowbox').draggable('option', 'cancel', 'img');
              }
              document.addEventListener('keydown', function (e) {
                if (e.ctrlKey && e.key === 'z') {
                  var _this2$game;
                  if ((_this2$game = _this2.game) !== null && _this2$game !== void 0 && (_this2$game = _this2$game.state) !== null && _this2$game !== void 0 && (_this2$game = _this2$game.hidden) !== null && _this2$game !== void 0 && _this2$game.length) {
                    _this2.undoMove();
                  }
                }
              });
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "newRound",
    value: function newRound() {
      //Set up queue
      this.game.queue.push('play');
      this.game.queue.push('READY');
      this.game.queue.push('DEAL\t1\t1\t144');
      this.game.queue.push('SHUFFLE\t1\t1');
      this.game.queue.push('DECK\t1\t' + JSON.stringify(this.returnDeck()));

      //Clear board
      this.game.board = {};
    }
  }, {
    key: "isArrayInArray",
    value: function isArrayInArray(arr, item) {
      var item_as_string = JSON.stringify(item);
      var contains = arr.some(function (ele) {
        return JSON.stringify(ele) === item_as_string;
      });
      return contains;
    }
  }, {
    key: "displayBoard",
    value:
    // displayBoard
    function () {
      var _displayBoard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$game;
        var timeInterval,
          index,
          deckSize,
          row,
          column,
          position,
          _row,
          _column,
          _position,
          tile,
          _row2,
          _column2,
          divname,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              timeInterval = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 0;
              console.log('Display board with pause of ' + timeInterval);
              index = 0;
              deckSize = 144;
              if (timeInterval) {
                $('#tiles').hide();
              }
              this.game.availableMoves = [];
              for (row = 1; row <= 21; row++) {
                for (column = 1; column <= 14; column++) {
                  position = "row".concat(row, "_slot").concat(column);
                  this.makeInvisible(position);
                }
              }
              if (!((_this$game = this.game) !== null && _this$game !== void 0 && _this$game.board) || Object.values(this.game.board).length === 0) {
                this.game.board = {};
                this.game.state.hidden = [];
                for (_row = 1; _row <= 21; _row++) {
                  for (_column = 1; _column <= 14; _column++) {
                    _position = "row".concat(_row, "_slot").concat(_column);
                    if (!this.isArrayInArray(this.emptyCells, [_row, _column]) && this.game.deck[0].hand.length > 0) {
                      tile = this.game.deck[0].hand.pop();
                      this.game.board[_position] = this.game.deck[0].cards[tile];
                    } else {
                      this.game.board[_position] = 'E';
                    }
                  }
                }
              }
              this.game.cardsLeft = deckSize - this.game.state.hidden.length;
              this.game.selected = '';
              $('.selected').removeClass('selected');
              _row2 = 1;
            case 1:
              if (!(_row2 <= 21)) {
                _context2.n = 5;
                break;
              }
              _column2 = 1;
            case 2:
              if (!(_column2 <= 14)) {
                _context2.n = 4;
                break;
              }
              divname = "row".concat(_row2, "_slot").concat(_column2);
              if (!(this.game.board[divname] !== 'E')) {
                _context2.n = 3;
                break;
              }
              $('#' + divname).html(this.returnCardImageHTML(this.game.board[divname]));
              if (this.game.state.hidden.includes(divname)) {
                this.makeInvisible(divname);
              } else {
                this.makeVisible(divname);
              }
              if (!timeInterval) {
                _context2.n = 3;
                break;
              }
              _context2.n = 3;
              return this.timeout(timeInterval);
            case 3:
              _column2++;
              _context2.n = 2;
              break;
            case 4:
              _row2++;
              _context2.n = 1;
              break;
            case 5:
              this.attachEventsToBoard();
              this.displayUserInterface();
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function displayBoard() {
        return _displayBoard.apply(this, arguments);
      }
      return displayBoard;
    }()
  }, {
    key: "makeInvisible",
    value: function makeInvisible(divname) {
      $("#".concat(divname)).addClass('invisible');
      $("#mahj-rowbox #".concat(divname)).removeClass('selected');
    }
  }, {
    key: "makeVisible",
    value: function makeVisible(divname) {
      $("#".concat(divname)).removeClass('invisible');
    }
  }, {
    key: "toggleCard",
    value: function toggleCard(divname) {
      $("#".concat(divname)).addClass('selected').removeClass('available').addClass('emphasis').delay(350).queue(function () {
        $("#".concat(divname)).removeClass('emphasis').dequeue();
      });
      this.game.selected = divname;
      this.getAvailableTiles();
    }
  }, {
    key: "untoggleCard",
    value: function untoggleCard(divname) {
      $("#".concat(divname)).removeClass('selected');
      this.game.selected = '';
      this.getAvailableTiles();
      $("#".concat(divname)).removeClass('available').delay(250).queue(function () {
        $("#".concat(divname)).addClass('available').dequeue();
      });
    }
  }, {
    key: "returnCardImageHTML",
    value: function returnCardImageHTML(name) {
      if (name[0] === 'E') {
        return '';
      } else {
        return '<img draggable="false" src="/mahjong/img/tiles/white/' + name + '.png" />';
      }
    }
  }, {
    key: "attachEventsToBoard",
    value: function attachEventsToBoard() {
      var mahjong_self = this;
      $('.slot').off();
      $('.slot').on('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this3 = this;
        var card;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              card = $(this).attr('id');
              if (mahjong_self.game.availableMoves.includes(card)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              if (!(mahjong_self.game.selected === card)) {
                _context3.n = 2;
                break;
              }
              //Selecting same card again
              mahjong_self.untoggleCard(card);
              return _context3.a(2);
            case 2:
              if (!(mahjong_self.game.selected === '')) {
                _context3.n = 3;
                break;
              }
              // New Card
              mahjong_self.toggleCard(card);
              return _context3.a(2);
            case 3:
              if (!(mahjong_self.game.board[card] === mahjong_self.game.board[mahjong_self.game.selected])) {
                _context3.n = 6;
                break;
              }
              $('.selected').addClass('valid');
              $('#' + card).addClass('selected');
              _context3.n = 4;
              return mahjong_self.timeout(100);
            case 4:
              mahjong_self.moveGameElement(mahjong_self.copyGameElement('#' + card), ".notfound.".concat(mahjong_self.game.board[card].toLowerCase()), {
                resize: 1,
                callback: function callback(id) {
                  document.getElementById(id).style.opacity = 0;
                }
              }, null);
              mahjong_self.moveGameElement(mahjong_self.copyGameElement('#' + mahjong_self.game.selected), ".notfound.".concat(mahjong_self.game.board[card].toLowerCase()), {
                resize: 1,
                callback: function callback(id) {
                  document.getElementById(id).style.opacity = 0;
                }
              }, null);
              mahjong_self.makeInvisible(card);
              mahjong_self.makeInvisible(mahjong_self.game.selected);
              mahjong_self.game.state.hidden.push(card);
              mahjong_self.game.state.hidden.push(mahjong_self.game.selected);
              mahjong_self.game.cardsLeft = mahjong_self.game.cardsLeft - 2;
              if (!(mahjong_self.game.cardsLeft === 0)) {
                _context3.n = 5;
                break;
              }
              mahjong_self.prependMove('win');
              mahjong_self.endTurn();
              return _context3.a(2);
            case 5:
              mahjong_self.game.selected = '';
              mahjong_self.displayUserInterface();
              _context3.n = 7;
              break;
            case 6:
              $(this).addClass('emphasis').delay(350).queue(function () {
                $(_this3).removeClass('emphasis').dequeue();
              });
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this);
      })));
    }
  }, {
    key: "getAvailableTiles",
    value: function getAvailableTiles() {
      var availableTiles = new Map([]);
      this.game.availableMoves = [];
      $('.mahj-rowbox .slot').removeClass('available').removeClass('valid').removeClass('invalid');
      for (var row = 1; row <= 21; row++) {
        for (var column = 1; column <= 14; column++) {
          if (row === 5 && column === 2 && !this.game.state.hidden.includes('row4_slot1') || row === 4 && column === 13 && !this.game.state.hidden.includes('row5_slot14')) {
            continue;
          }
          if (row >= 2 && row <= 7 && column >= 5 && column <= 10) {
            if (!this.game.state.hidden.includes("row".concat(row + 7, "_slot").concat(column))) {
              continue;
            }
          }
          if (row >= 10 && row <= 13 && column >= 6 && column <= 9) {
            if (!this.game.state.hidden.includes("row".concat(row + 5, "_slot").concat(column))) {
              continue;
            }
          }
          if (row >= 16 && row <= 17 && column >= 7 && column <= 8) {
            if (!this.game.state.hidden.includes("row".concat(row + 3, "_slot").concat(column))) {
              continue;
            }
          }
          if (row >= 19 && row <= 20 && column >= 7 && column <= 8) {
            if (!this.game.state.hidden.includes("row21_slot".concat(column))) {
              continue;
            }
          }
          if (
          // \/ checking if right or left tile is unlocked or empty
          (this.game.state.hidden.includes("row".concat(row, "_slot").concat(column - 1)) || this.game.board["row".concat(row, "_slot").concat(column - 1)] === 'E' || this.game.state.hidden.includes("row".concat(row, "_slot").concat(column + 1)) || this.game.board["row".concat(row, "_slot").concat(column + 1)] === 'E') && this.game.board["row".concat(row, "_slot").concat(column)] !== 'E' && !this.game.state.hidden.includes("row".concat(row, "_slot").concat(column)) ||
          // /\ checking if right or left tile is unlocked or empty
          // \/ checking two outermost rows
          row === 4 && column === 1 && !this.game.state.hidden.includes('row4_slot1') || row === 5 && column === 14 && !this.game.state.hidden.includes('row5_slot14')) {
            // /\ checking two outermost rows
            if (availableTiles.get(this.game.board["row".concat(row, "_slot").concat(column)]) !== undefined) {
              availableTiles.set(this.game.board["row".concat(row, "_slot").concat(column)], availableTiles.get(this.game.board["row".concat(row, "_slot").concat(column)]) + 1);
            } else {
              availableTiles.set(this.game.board["row".concat(row, "_slot").concat(column)], 1);
            }
            this.game.availableMoves.push("row".concat(row, "_slot").concat(column));
            $("#row".concat(row, "_slot").concat(column)).addClass('available');
            if (this.game.selected && this.game.selected !== "row".concat(row, "_slot").concat(column)) {
              if (this.game.board["row".concat(row, "_slot").concat(column)] == this.game.board[this.game.selected]) {
                $("#row".concat(row, "_slot").concat(column)).addClass('valid');
              } else {
                $("#row".concat(row, "_slot").concat(column)).addClass('invalid');
              }
            }
          }
        }
      }
      var hints = [];
      for (var i = 0; i < this.game.availableMoves.length - 1; i++) {
        for (var j = i + 1; j < this.game.availableMoves.length; j++) {
          if (this.game.board[this.game.availableMoves[i]] === this.game.board[this.game.availableMoves[j]]) {
            hints.push([this.game.availableMoves[i], this.game.availableMoves[j]]);
          }
        }
      }
      return hints;
    }
  }, {
    key: "displayUserInterface",
    value: function () {
      var _displayUserInterface = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var tilesLeftToUnlock, c, mahjong_self, html, options, tiles, _iterator, _step, tile, num_found;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              tilesLeftToUnlock = this.getAvailableTiles();
              if (!(this.game.cardsLeft > 0 && (!tilesLeftToUnlock || tilesLeftToUnlock.length == 0))) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return sconfirm('There are no more available moves to make, start new game?');
            case 1:
              c = _context4.v;
              if (!c) {
                _context4.n = 2;
                break;
              }
              this.prependMove('lose');
              this.endTurn();
              return _context4.a(2);
            case 2:
              mahjong_self = this;
              html = "Remove tiles in pairs until none remain. Tiles must not be blocked to their left and right.";
              options = [];
              options.push({
                id: 'hint',
                label: "<span>Hint: ".concat(tilesLeftToUnlock.length, "<span class=\"hidable\"> pairs available</span></span>")
              });
              if (this.game.state.hidden.length > 0) {
                options.push({
                  id: 'undo',
                  label: 'Undo'
                });
              }
              this.game.status = html;
              this.hud.updateStatus(this.game.status);
              this.hud.updateCards([]);
              this.hud.updateMenu(options, function (action) {
                if (action === 'undo') {
                  mahjong_self.undoMove();
                  return;
                }
                if (action == 'hint' && tilesLeftToUnlock.length > 0) {
                  var pair = tilesLeftToUnlock.pop();
                  $("#".concat(pair[0], ", #").concat(pair[1])).addClass('hint').delay(400).queue(function () {
                    $(this).removeClass('hint').dequeue();
                  }).delay(300).queue(function () {
                    $(this).addClass('hint').dequeue();
                  }).delay(400).queue(function () {
                    $(this).removeClass('hint').dequeue();
                  }).delay(300).queue(function () {
                    $(this).addClass('hint').dequeue();
                  }).delay(400).queue(function () {
                    $(this).removeClass('hint').dequeue();
                  });
                  tilesLeftToUnlock.unshift(pair);
                }
                if (action == 'hint') {
                  mahjong_self.displayUserInterface();
                }
              });
              tiles = this.returnTiles();
              html = '';
              _iterator = _createForOfIteratorHelper(tiles);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  tile = _step.value;
                  num_found = this.returnHidden(tile);
                  html += "<div class=\"scoreboard_tile ".concat(num_found > 1 ? 'found' : 'notfound', " ").concat(tile.toLowerCase(), "\">").concat(this.returnCardImageHTML(tile), "</div>\n               <div class=\"scoreboard_tile ").concat(num_found > 3 ? 'found' : 'notfound', " ").concat(tile.toLowerCase(), "\">").concat(this.returnCardImageHTML(tile), "</div>\n       ");
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              $('#tiles').html(html);
              $('#tiles').show();
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function displayUserInterface() {
        return _displayUserInterface.apply(this, arguments);
      }
      return displayUserInterface;
    }()
  }, {
    key: "undoMove",
    value: function undoMove() {
      if (this.game.selected !== '') {
        this.untoggleCard(this.game.selected);
      }
      this.makeVisible(this.game.state.hidden.pop());
      this.makeVisible(this.game.state.hidden.pop());
      this.game.cardsLeft += 2;
      this.displayUserInterface();
    }

    ////////////////////
    // VERY IMPORTANT //
    ////////////////////
    //
    // this is the main function for queue-based games. cryptographic logic
    // and shared commands (DEAL, SHUFFLE, etc.) are powered by the underlying
    // game engine, which kicks instructions here if it doesn't recognize them.
    //
    // the convention is for game-level instructions to be lowercase and game-
    // engine commands to be UPPERCASE so as to easily.
    //
    // return 0 -- halts execution
    // return 1 -- continues execution
    //
    // clear the queue manually and return 1 if there is no user-input at this
    // point in the game. if there is user-input, return 0 and the QUEUE will
    // being to execute again the next time a move is received over the network.
    //
  }, {
    key: "handleGameLoop",
    value: function handleGameLoop() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      ///////////
      // QUEUE //
      ///////////
      if (this.game.queue.length > 0) {
        var qe = this.game.queue.length - 1;
        var mv = this.game.queue[qe].split('\t');
        if (mv[0] === 'play') {
          if (this.browser_active) {
            this.game.queue.splice(qe, 1);
            //Reset/Increment State
            this.displayBoard(2);
          }
        }
        if (mv[0] === 'lose') {
          this.game.queue.splice(qe, 1);
          this.newRound();
          this.game.state.session.round++;
          this.game.state.session.losses++;
          this.game.queue.push("ROUNDOVER\t".concat(JSON.stringify([]), "\troundover\t").concat(JSON.stringify([this.publicKey])));
          return 1;
        }
        if (mv[0] === 'win') {
          this.game.queue.splice(qe, 1);
          this.game.state.session.round++;
          this.game.state.session.wins++;
          this.displayModal('Congratulations! Here is your fortune', this.returnFortune());
          this.newRound();
          this.game.queue.push("ROUNDOVER\t".concat(JSON.stringify([this.publicKey]), "\troundover\t").concat(JSON.stringify([])));
          return 1;
        }
        if (mv[0] === 'move') {
          this.game.queue.splice(qe, 1);
          return 1;
        }
        return 0;
      }

      //
      // nothing in queue, return 0 and halt
      //
      return 0;
    }
  }, {
    key: "returnHidden",
    value: function returnHidden(tile) {
      var count = 0;
      var _iterator2 = _createForOfIteratorHelper(this.game.state.hidden),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var slot = _step2.value;
          if (this.game.board[slot] == tile) {
            count++;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return count;
    }
  }, {
    key: "returnTiles",
    value: function returnTiles() {
      return ['Pin1', 'Pin2', 'Pin3', 'Pin4', 'Pin5', 'Pin6', 'Pin7', 'Pin8', 'Pin9', 'Man1', 'Man2', 'Man3', 'Man4', 'Man5', 'Man6', 'Man7', 'Man8', 'Man9', 'Sou1', 'Sou2', 'Sou3', 'Sou4', 'Sou5', 'Sou6', 'Sou7', 'Sou8', 'Sou9', 'Pin5-Dora', 'Man5-Dora', 'Sou5-Dora', 'Ton', 'Nan', 'Shaa', 'Pei', 'Chun', 'Hatsu'];
    }
  }, {
    key: "returnDeck",
    value: function returnDeck() {
      var cards = this.returnTiles();
      var deck = {};
      var index = 1;
      for (var i = 0; i < cards.length; i++) {
        for (var j = 0; j < 4; j++) {
          deck[index++] = cards[i];
        }
      }
      return deck;
    }
  }, {
    key: "returnFortune",
    value: function returnFortune() {
      var fortunes = ['Do not be afraid of competition', 'An exciting opportunity lies ahead of you', 'You will always be surrounded by true friends', 'You are kind and friendly', 'You should be able to undertake and complete anything', 'You are wise beyond your years', 'A routine task will turn into an enchanting adventure', 'Beware of all enterprises that require new clothes', 'Be true to your work, your word, and your friends', 'Goodness is the only investment that never fails', 'A journey of a thousand miles begins with a single step', 'Forget injuries, but never forget kindnesses', 'Respect yourself and others will respect you', 'A man cannot be comfortable without his own approval', 'It is easier to stay out than to get out', 'You will receive money from an unexpected source', 'Attitude is a little thing that makes a big difference', 'Plan for many pleasure ahead', 'Experience is the best teacher', 'You ability to juggle many tasks will take you far', 'Once you make a decision the universe conspires to make it happen', 'Make yourself necessary to someone', 'The only way to have a friend is to be one', 'Nothing great was ever achieved without enthusiasm', 'Live this day as if it were your last', 'Your life will be happy and peaceful', 'Bloom where you are planted', 'Move in the direction of your dreams', "Help! I'm being held prisoner in a fortune cookie factory", 'The one you love is closer than you think', 'In dreams and in love there are no impossibilities'];
      return fortunes[Math.floor(fortunes.length * Math.random())];
    }
  }]);
}(OnePlayerGameTemplate);
module.exports = Mahjong;